import store from '@/store'

const state = {
  loginDialogState: false,
  myAccountDialogState: false,
  myAccountDesktopDialogState: false,
  sportMenuState: false,
  hamburgerMenuState: false,
  competitionSelect: false,
  betslipState: false,
  betslipMsg: {
    active: false,
    data: {}
  },
  loginFields: {
    username: '',
    password: '',
    showPassword: false,
    answers: {},
    hasError: false
  },
  singleBetslipState: {
    active: false,
    resolve: null,
    reject: null
  },
  betslipConfirm: {
    active: false,
    data: {}
  },
  geolocationDialogState: false,
  geolocationMessage: {},
  headerMessagesData: {},
  headerMessageState: false,
  messageDialogState: false,
  messageDialogMsg: {}
}

const getters = {
  getMyAccountDialogState (state) {
    return state.myAccountDialogState
  },
  getMyAccountDesktopDialogState (state) {
    return state.myAccountDesktopDialogState
  },
  getloginFields (state) {
    return state.loginFields
  },
  getLoginDialogState (state) {
    return state.loginDialogState
  },

  getSportsMenuState (state) {
    return state.sportMenuState
  },
  getHamburgerMenuState (state) {
    return state.hamburgerMenuState
  },

  getBetslipState (state) {
    return state.betslipState
  },

  getSingleBetslipState (state) {
    return state.singleBetslipState
  },

  getBetslipMsg (state) {
    return state.betslipMsg
  },

  getBetslipConfirm (state) {
    return state.betslipConfirm
  },
  getGeolocationDialogState () {
    return state.geolocationDialogState
  },
  getGeolocationMessage () {
    return state.geolocationMessage
  },
  getHeaderMessagesData () {
    return state.headerMessagesData
  },
  getMessageDialogState () {
    return state.messageDialogState
  },
  getMessageDialogMsg () {
    return state.messageDialogMsg
  },
  getHeaderMessageState () {
    return state.headerMessageState
  },
  getCompetitionSelectDialogState (state) {
    return state.competitionSelect
  }
}

const actions = {
  closeAll (context) {
    context.dispatch('deactivateMyAccountDialog')
    context.dispatch('deactivateLoginDialog')
    context.dispatch('deactivateSportsMenu')
    context.dispatch('deactivateHamburgerMenu')
    context.dispatch('deactivateBetslip')
    context.dispatch('deactivateCompetitionSelectDialog')
    context.dispatch('deactivateMyAccountDesktopDialog')
  },

  activateMyAccountDialog (context) {
    context.dispatch('closeAll')
    context.dispatch('loginFields')
    store.commit('setLoginErrorMessage', '')
    store.commit('setLoginChallenges', null)
    context.commit('setMyAccountDialogState', true)
  },
  deactivateMyAccountDialog (context) {
    context.commit('setMyAccountDialogState', false)
  },
  activateMyAccountDesktopDialog (context) {
    context.dispatch('closeAll')
    context.commit('setMyAccountDesktopDialogState', true)
  },
  deactivateMyAccountDesktopDialog (context) {
    context.commit('setMyAccountDesktopDialogState', false)
  },
  loginFields (context) {
    context.commit('setloginFields')
  },
  activateLoginDialog (context) {
    context.dispatch('closeAll')
    context.dispatch('loginFields')
    store.commit('setLoginErrorMessage', '')
    store.commit('setLoginChallenges', null)
    context.commit('setGeolocationDialogState', false)
    context.commit('setLoginDialogState', true)
  },
  activeGeolocationDialog (context) {
    context.commit('setGeolocationDialogState', true)
  },

  deactivateLoginDialog (context) {
    context.commit('setLoginDialogState', false)
  },
  deactivateGeolocationDialog (context) {
    context.commit('setGeolocationDialogState', false)
  },

  activateSportsMenu (context) {
    context.dispatch('closeAll')
    context.commit('setSportsMenuState', true)
  },

  deactivateSportsMenu (context) {
    context.commit('setSportsMenuState', false)
  },
  activateHamburgerMenu (context) {
    context.dispatch('closeAll')
    context.commit('setHamburgerMenuState', true)
  },

  deactivateHamburgerMenu (context) {
    context.commit('setHamburgerMenuState', false)
  },

  activateBetslip (context) {
    store.commit('sbBetslipState/setActiveBetSlip', 'BetSlip')
    const el = document.body
    var htmlElement = document.querySelector('html')
    context.dispatch('closeAll')
    el.classList.add('betslipactive')
    htmlElement.classList.add('overflowHidden')
    context.commit('setBetslipState', true)
    //
    context.dispatch('deactivateSingleBetslip')
    //
    store.dispatch('sbBetslipState/updateBetSlip')
  },

  deactivateBetslip (context) {
    // store.commit('sbBetslipState/setActiveBetSlip', false)
    const el = document.body
    var htmlElement = document.querySelector('html')
    el.classList.remove('betslipactive')
    htmlElement.classList.remove('overflowHidden')
    context.commit('setBetslipState', false)
  },

  activateSingleBetslip (context) {
    store.commit('sbBetslipState/setActiveBetSlip', 'SingleBetSlip')
    // context.commit('setSingleBetslipState', true)
    return new Promise((resolve, reject) => {
      context.commit('setSingleBetslipState', {
        active: true,
        resolve,
        reject
      })
    })
  },

  deactivateSingleBetslip (context) {
    // store.commit('sbBetslipState/setActiveBetSlip', false)
    context.commit('setSingleBetslipState', {
      active: false,
      resolve: null,
      reject: null
    })
  },

  activateBetslipMsg (context, data) {
    // context.dispatch('closeAll')
    context.commit('setBetslipMsg', {
      active: true,
      data: data
    })
  },
  deactivateBetslipMsg (context, data) {
    context.state.betslipMsg.active = false
  },

  activateBetslipConfirm (context, data) {
    return new Promise((resolve, reject) => {
      context.commit('setBetslipConfirm', {
        active: true,
        data: data,
        resolve,
        reject
      })
    })
  },

  deactivateBetslipConfirm (context) {
    context.state.betslipConfirm.active = false
  },
  activateMessageDialog (context) {
    console.log('activateMessageDialog')
    context.commit('setMessageDialogState', true)
  },
  deactivateMessageDialog (context) {
    context.commit('setMessageDialogState', false)
  },
  activateCompetitionSelectDialog (context) {
    context.dispatch('closeAll')
    context.commit('setCompetitionSelect', true)
  },
  deactivateCompetitionSelectDialog (context) {
    context.commit('setCompetitionSelect', false)
  }
}

const mutations = {
  setMyAccountDialogState (state, value) {
    state.myAccountDialogState = value
  },
  setMyAccountDesktopDialogState (state, value) {
    state.myAccountDesktopDialogState = value
  },
  setloginFields (state) {
    state.loginFields = {
      username: '',
      password: '',
      showPassword: false,
      answers: {},
      hasError: false
    }
  },
  setLoginDialogState (state, value) {
    state.loginDialogState = value
  },

  setSportsMenuState (state, value) {
    state.sportMenuState = value
  },
  setHamburgerMenuState (state, value) {
    state.hamburgerMenuState = value
  },

  setBetslipState (state, value) {
    state.betslipState = value
  },

  setSingleBetslipState (state, value) {
    state.singleBetslipState = value
  },

  setBetslipMsg (state, value) {
    state.betslipMsg = value
  },
  setCompetitionSelect (state, value) {
    state.competitionSelect = value
  },
  setBetslipConfirm (state, value) {
    state.betslipConfirm = value
  },
  setGeolocationDialogState (state, value) {
    state.geolocationDialogState = value
  },
  setGeolocationMessage (state, value) {
    state.geolocationMessage = value
  },
  setHeaderMessagesData (state, value) {
    state.headerMessagesData = value
  },
  setMessageDialogState (state, value) {
    console.log('setMessageDialogState')
    console.log(value)
    state.messageDialogState = value
  },
  setMessageDialogMsg (state, value) {
    state.messageDialogMsg = value
  },
  setHeaderMessageState (state, value) {
    console.log('setHeaderMessageState')
    console.log(value)
    state.headerMessageState = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/overlay.js